<template>
<CaseSummaryContainer :loading="isLoading">
  <Header slot="header" :heading="'Case Summaries'" :methodology="methodology" @print="print"></Header>
  <CaseBlockFilter slot="caseBlockFilter" v-show="filterValues" :cases="cases" :filterValues="filterValues" @applyFilter="applyFilter"></CaseBlockFilter>
  <PrintArea slot="printArea" :filteredCases="cases" :reportFilter="reportFilter" />
  <CaseBlock slot="caseBlock" v-if="cases.length" v-for="oigCase in cases" v-bind:key="oigCase.id" :oigCase="oigCase"></CaseBlock>
  <b-jumbotron fluid class="text-center" slot="caseBlock" v-show="typeof cases != 'undefined' && !cases.length">There are no cases which match your selected filters.</b-jumbotron>
</CaseSummaryContainer>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-142178256-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-142178256-1');
</script>
<script>
import CaseSummaryContainer from '@/components/CaseSummaryContainer.vue'
import Header from '@/components/Header'
import CaseBlockFilter from '@/components/SCMU/CaseSummaries/CaseBlockFilter'
export default {
  name: 'app',
  components: {
    CaseBlockFilter,
    CaseBlock: () => import( /* webpackChunkName: 'scmuCaseBlock' */ '@/components/SCMU/CaseSummaries/CaseBlock.vue'),
    Header,
    CaseSummaryContainer,
    PrintArea: () => import( /* webpackChunkName: 'scmuPrintArea' */ '@/components/SCMU/CaseSummaries/PrintArea.vue')
  },
  data() {
    return {
      isLoading: true,
      filter: {},
      methodology: null
    }
  },
  created() {
    //this.$store.dispatch('scmu/getCases')
    this.$store.dispatch('scmu/getFilterValues')
  },
  methods: {
    applyFilter: function (filter) {
      this.isLoading = true
      return this.$store.dispatch('scmu/setFilter', filter).then(() => {
        return this.$store.dispatch('scmu/getCases').then(() => {
          this.isLoading = false
        })
      })
      // this.filter = filter
    },
    sortCases: function (a, b) {
      if (Date.parse(a.date) > Date.parse(b.date)) return 1
      if (Date.parse(a.date) < Date.parse(b.date)) return -1
      return 0
    },
    displayFormat: function (text) {
      text = text.replace(/([A-Z])/g, ' $1')
      text = text.charAt(0)
        .toUpperCase() + text.slice(1)
      return text
    },
    convertValue: function (label, value) {
      let displayValues = []
      if (label === 'reportingPeriod') {
        value.forEach((x, y) => {
          this.data.reportingPeriods.filter(r => {
            if (r.value === x) displayValues[y] = r.text
          })
        })
        return displayValues.join(', ')
      } else {
        return value.join(', ')
      }
    },
    print: function () {
      window.print()
    }
  },
  computed: {
    cases() {
      return this.$store.state.scmu.cases
    },
    filterValues() {
      return this.$store.getters['scmu/filterValues']
    },
    reportFilter: function () {
      let tempFilter = {}
      let filter = this.$store.state.scmu.filter
      if (Object.keys(filter).length === 0) return tempFilter
      Object.keys(filter)
        .forEach((key) => {
          if (filter[key] != null && filter[key].length) {
            tempFilter[key] = filter[key]
          }
        })
      return tempFilter
    }
  }

}
</script>

<style>
</style>
